module.exports = __webpack_public_path__ + "img/3-3-2-2.733648e9.png";